import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import PlatformSection from './components/PlatformSection';
import VideoSection from './components/VideoSection';
import MarqueeSection from './components/MarqueeSection';
import IndustriesSection from './components/IndustriesSection';
import WhyAndTestimonialsSection from './components/WhyAndTestimonialsSection';
import CTAStrip from '../../components/feature/CTAStrip';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import BlogPreviewSection from './components/BlogPreviewSection';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-thl-dark">
      <Navbar />
      <HeroSection />
      <ServicesSection />
      <PlatformSection />
      <VideoSection />
      <MarqueeSection />
      <IndustriesSection />
      <WhyAndTestimonialsSection />
      <BlogPreviewSection />
      <CTAStrip />
      <Footer />
    </div>
  );
}
